type ClassValue =
	| string
	| number
	| boolean
	| null
	| undefined
	| ClassValue[]
	| Record<string, unknown>;

function toClassString(value: ClassValue): string {
	if (value === null || value === undefined || value === false) {
		return "";
	}

	if (typeof value === "string" || typeof value === "number") {
		return String(value);
	}

	if (Array.isArray(value)) {
		return value.map(toClassString).filter(Boolean).join(" ");
	}

	if (typeof value === "object") {
		return Object.entries(value)
			.filter(([, condition]) => Boolean(condition))
			.map(([className]) => className)
			.join(" ");
	}

	return "";
}

export function cn(...inputs: ClassValue[]): string {
	return inputs
		.map(toClassString)
		.map((value) => value.trim())
		.filter(Boolean)
		.join(" ");
}
